export default __webpack_public_path__ + "static/media/Voiceflow.ce1ba481.png";